import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import { fmtCount } from './vocabulary'

// A picker over one stratum, built from the window's own facets rather than a
// list held here: seal causes are an open vocabulary (a client may add one
// without a server release), and client versions are whatever has shipped.
//
// Options come back unnarrowed by the current selection, so choosing one never
// removes the others. A facet with a null value is spans carrying no value at
// all — every span declared before these fields shipped — and it is offered as
// a labelled option rather than hidden, because its size is what says whether
// a slice is representative yet.
const StratumFilter = ({ label, value, facets, onChange, width = 180 }) => {
  const options = facets || []
  const total = options.reduce((sum, facet) => sum + facet.n, 0)

  return (
    <TextField
      select
      size="small"
      label={label}
      sx={{ width }}
      value={value ?? ''}
      onChange={(event) => onChange(event.target.value || null)}
      disabled={!options.length}
    >
      <MenuItem value="">All{total ? ` (${fmtCount(total)})` : ''}</MenuItem>
      {options.map(({ value: option, n }) => (
        <MenuItem
          key={option ?? '__unset__'}
          value={option ?? ''}
          // The unset bucket is countable but not selectable: the endpoint
          // filters on a value, and "absent" is not one.
          disabled={option == null}
        >
          {option ?? 'not reported'}
          <Typography
            component="span"
            variant="caption"
            color="text.secondary"
            sx={{ ml: 1 }}
          >
            {fmtCount(n)}
          </Typography>
        </MenuItem>
      ))}
    </TextField>
  )
}

export default StratumFilter
